import { render, staticRenderFns } from "./PracticeLocationAdd.vue?vue&type=template&id=0737cbcd&scoped=true&"
import script from "./PracticeLocationAdd.vue?vue&type=script&lang=js&"
export * from "./PracticeLocationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737cbcd",
  null
  
)

export default component.exports